//Core
import {AxiosResponse} from "axios";
import {User} from "@auth0/auth0-react";
//Services
import clientBuilder from "./clientBuilder";
//Redux
import {store} from "@/redux/store";
import {endFetch, startFetch} from "@/redux/app/appSlice";
//Types
import {TGetUserResponse, TUserDataResponse} from "@/types/services/user/response/userDataResponseTypes";
import {TGetUserRequest} from "@/types/services/user/request/getUserRequestTypes";
import {TUpdateUserRequest} from "@/types/services/user/request/updateUserRequestTypes";
import {TDefaultStatusResponse} from "@/types/services/defaultResponse/defaultStatusResponseTypes";
import {TCreateUserRequest} from "@/types/services/user/request/createUserRequestTypes";
//Utils
import {fetchListItems} from "@/utils/fetchListItems";

const userClient = clientBuilder();

export const getUserAPI = async (userId?: string) => {
    const data: TGetUserRequest = {
        user_id: userId ?? store.getState().user.userId,
    }
    try {
    store.dispatch(startFetch(fetchListItems.getUser))
         const response: AxiosResponse<TGetUserResponse> = await userClient.post(`get_user`, data);
        // console.log(response)
        if (response?.data && response.data.errors === 0) {
            return {
                errors: 0,
                message: response.data.message,
                data: response.data.data as TUserDataResponse
            };
        } else {
            return {
                errors: response.data.errors,
                message: response.data.message,
                data: null
            }
        }
    } catch (error) {
        console.log(error);
        return null;
    } finally {
        store.dispatch(endFetch(fetchListItems.getUser))
    }
};

export const createUserAPI = async (user: User) => {
    const data: TCreateUserRequest = {
        user_id: user.sub || '',
        name: user.name || user.username || user.nickname || user.given_name || user.family_name || user.email,
        email: user.email || '',
        image: user.picture || null,
    }
    try {
        store.dispatch(startFetch(fetchListItems.updateUser))
        const response: AxiosResponse<TDefaultStatusResponse> = await userClient.post(`create_user`, data);
        if (response?.data?.errors === 0 && response?.data?.data?.status) {
            const response = await getUserAPI(data.user_id);
            if (response?.data) {
                return response?.data;
            } else return null;
        } else return null;

    } catch (error) {
        console.log(error);
        return null;
    } finally {
        store.dispatch(endFetch(fetchListItems.updateUser))
    }
};

//Don't use this function at the moment
export const updateUserAPI = async (data: TUpdateUserRequest) => {
    try {
        store.dispatch(startFetch(fetchListItems.updateUser))
        const response: AxiosResponse<TDefaultStatusResponse> = await userClient.put(`update_user`, data);
        if (response?.data && response.data.errors === 0) {
            return response.data.data;
        } else return null;

    } catch (error) {
        console.log(error);
        return null;
    } finally {
        store.dispatch(endFetch(fetchListItems.updateUser))
    }
};

